import styled from "styled-components";
import {styledByTheme} from "../../../../../themes/architecture/styled-by-theme";

const FilterByDefaultBox = styled.div`
  font-size: ${props => props.theme.font.size.large};
  flex-grow: 1;
`;

const FilterByMrGreenBox = styled(FilterByDefaultBox)`
  font-size: 1.4rem;
`;

const FilterBySIBox = styled(FilterByDefaultBox)`
    color: ${({theme}) => theme.colors.textLight};
    font-size: 1.4rem;
    font-weight: 400;
`;

export const FilterByBox = styledByTheme(FilterByDefaultBox)
    .forSI(FilterBySIBox)
    .forSICis(FilterBySIBox)
    .forMrGreen(FilterByMrGreenBox)
    .forMrGreenCis(FilterByMrGreenBox).apply();
